import { ReactNode, useCallback } from 'react';
import { useIntl } from 'react-intl';
import translations from 'translations/en.json';

export type TranslationKey = keyof typeof translations;

type PrimitiveType = string | number | boolean | null | undefined | Date;
type FormatXMLElementFn<T, R = string | Array<string | T>> = (
  parts: Array<string | T>,
) => R;

export interface Translate<T = string, R = T> {
  (
    key: TranslationKey,
    values?: Record<
      string,
      PrimitiveType | ReactNode | FormatXMLElementFn<string, ReactNode>
    >,
  ): string;
  (
    key: TranslationKey,
    values?: Record<
      string,
      PrimitiveType | ReactNode | FormatXMLElementFn<T, R>
    >,
  ): ReactNode;
}

export const useTranslation = (
  id: TranslationKey,
  values?: Record<string, any>,
) => {
  const intl = useIntl();

  return intl.formatMessage({ id }, values);
};

export const useTranslate = (): Translate => {
  const intl = useIntl();
  const translate = useCallback(
    (id: TranslationKey, values?: any) => intl.formatMessage({ id }, values),
    [intl],
  ) as Translate;

  return translate;
};
export type UseTranslateType = ReturnType<typeof useTranslate>;
